export default "__VITE_ASSET__BMQx$yg3__"